import { IResource } from 'kits/apiKit3/legacy';
import React, { ReactElement } from 'react';
import { useAreaCardState } from './AreaCard.state';
import AreaCardView from './AreaCard.view';

export interface IAreaCardProps {
    fluid?: boolean;
    panelHeader: string;
    isPanelOpen: boolean;
    dismissPanel: () => void;
    campusId: string | undefined;
    areaName: string;
    setAreaName: React.Dispatch<React.SetStateAction<string>>;
    areaTag: string;
    setAreaTag: React.Dispatch<React.SetStateAction<string>>;
    vertical?: boolean;
    area: any;
    team?: any;
    onClick?: (e: any) => void;
    onRenderActions?: () => ReactElement;
    setPanelHeader: React.Dispatch<React.SetStateAction<string>>;
    openPanel: () => void;
    areaId: string;
    modalIsOpen: boolean;
    setModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
    seedAreaEditPanel: (areaId: string, name?: string, tag?: string, sortNumber?: number) => void;
    onStar(a: IResource, isStared: boolean): void;
    setIsAddAreaGroupSelected: React.Dispatch<React.SetStateAction<boolean>>;
}

const AreaCard: React.FC<IAreaCardProps> = (props) => {
    const state = useAreaCardState(props.area, props.onStar);
    const {
        vertical,
        area,
        areaId,
        areaName,
        areaTag,
        setAreaTag,
        modalIsOpen,
        seedAreaEditPanel,
        panelHeader,
        isPanelOpen,
        campusId,
        onClick,
        setPanelHeader,
        openPanel,
        setModalIsOpen,
        dismissPanel,
        setAreaName,
        setIsAddAreaGroupSelected
    } = props;

    return (
        <AreaCardView
            {...{
                ...state,
                ...{
                    vertical,
                    title: area.attributes.displayName,
                    label: area.attributes.areaLabel || area.attributes.areaGroupLabel,
                    description: area.attributes.desc,
                    team: state.msTeam,
                    onClick,
                    setPanelHeader,
                    onRenderActions: state.renderAreaActions,
                    openPanel,
                    areaId,
                    modalIsOpen,
                    setModalIsOpen,
                    seedAreaEditPanel,
                    panelHeader,
                    isPanelOpen,
                    dismissPanel,
                    campusId,
                    areaName,
                    setAreaName,
                    areaTag,
                    setAreaTag,
                    setIsAddAreaGroupSelected
                }
            }}
        ></AreaCardView>
    );
};
export default AreaCard;
